import React, { useState } from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';
import { ParkingQueueMutations } from '../../hooks/parkingQueue';
import { ParkingQueueEntry, QueueCloseReason, QUEUE_CLOSE_REASON_LABELS } from '../../types/parkingQueue';
import { PII_HINT } from './queueLabels';

interface CloseProps { show: boolean; onHide: () => void; entry: ParkingQueueEntry; mutations: ParkingQueueMutations }

/** Avsluta köplats by hand, with a reason and an optional note. */
const CloseEntryModal: React.FC<CloseProps> = ({ show, onHide, entry, mutations }) => {
    const [reason, setReason] = useState<QueueCloseReason>('withdrawn');
    const [note, setNote] = useState('');
    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton><Modal.Title>Avsluta köplats</Modal.Title></Modal.Header>
            <Modal.Body>
                {mutations.error && <Alert variant="danger">{mutations.error}</Alert>}
                <Form.Group className="mb-3">
                    <Form.Label>Anledning</Form.Label>
                    {(Object.keys(QUEUE_CLOSE_REASON_LABELS) as QueueCloseReason[]).map(r => (
                        <Form.Check key={r} type="radio" id={`close-${r}`} label={QUEUE_CLOSE_REASON_LABELS[r]} checked={reason === r} onChange={() => setReason(r)} />
                    ))}
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Anteckning</Form.Label>
                    <Form.Control as="textarea" rows={2} value={note} onChange={e => setNote(e.target.value)} />
                    <Form.Text muted>{PII_HINT}</Form.Text>
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide} disabled={mutations.submitting}>Avbryt</Button>
                <Button variant="danger" disabled={mutations.submitting}
                    onClick={async () => { await mutations.closeEntry(entry.key, reason, note.trim() || undefined); onHide(); }}>
                    {mutations.submitting ? 'Sparar…' : 'Avsluta'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CloseEntryModal;
